import { useState } from 'react';
import Table, { useTable } from 'common/components/table';
import useRouter from 'use-react-router';
import { Row, Col } from 'reactstrap';

import useDrawer from 'common/components/drawer/useDrawer';
import { useActions } from 'utils/hooks';
import * as companyActions from 'store/companies/actions';

import settingsIcon from '@/library/assets/svg/common/settings.svg';
import edit from 'assets/svg/actions/edit-empty.svg';
import TableActions from 'components/layouts/table';
import Switch from 'common/components/form/inputs/Switch';
import DangerousActionModal from 'common/components/modals/DangerousActionModal';

import Drawer from './form';
import SvgRender from 'common/components/general/SvgRender';
import switchIcon from 'assets/svg/common/switch.svg';
import paths from '@/routing/routes/_paths';

const Companies = () => {
  const { history } = useRouter();
  const [updateCompany] = useActions([companyActions.updateCompany]);
  const [active, setActive] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalItem, setModalItem] = useState(null);

  const drawer = useDrawer(false);
  const table = useTable({
    label: 'organizations',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true,
        width: 2
      },
      {
        header: 'Domain',
        key: 'domain',
        type: 'string',
        sort: true,
        width: 2
      },
      {
        header: 'Schema name',
        key: 'schema',
        type: 'string',
        sort: true,
        width: 2
      },
      {
        header: 'Login Synonyms',
        key: 'synonyms',
        type: 'collection',
        canFilter: false,
        width: 2
      },
      {
        header: 'Status',
        key: 'active',
        type: 'boolean',
        headerClassName: 'd-flex justify-content-center',
        className: 'text-center',
        options: [
          { label: 'Yes', value: 'true' },
          { label: 'No', value: 'false' }
        ],
        width: 2
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 2
      }
    ]
  });

  const changeEnabled = data => {
    const item = data || modalItem;

    updateCompany({ ...item, active: !item.active, table: 'organizations' });
  };

  const openEnabledModal = data => {
    if (data.active) {
      setModalItem(data);
      setIsModalOpen(true);
    } else {
      changeEnabled(data);
    }
  };

  return (
    <Row>
      <Col xs={12} className="mb-5">
        <TableActions title="Companies" actions={[{ type: 'search' }]} />
      </Col>
      <Col xs={12}>
        <Table
          loader
          drawer={<Drawer drawer={drawer} active={active} />}
          onArchive={() => {}}
          rows={{
            domain: (data, col) => (
              <a
                href={`https://${data.domain}`}
                rel="noopener noreferrer"
                target="_blank"
              >{`https://${data.domain}`}</a>
            ),
            active: data => (
              <Switch
                className="mb-0"
                value={data.active}
                onChange={() => openEnabledModal(data)}
                size="sm"
              />
            ),
            synonyms: data =>
              data.synonyms && data.synonyms.length ? data.synonyms.join(', ') : null,
            actions: {
              options: [
                {
                  label: 'Settings',
                  icon: settingsIcon,
                  onClick: (_, row) => history.push(`${paths.company_settings}/${row.id}`)
                },
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            }
          }}
          {...table}
        />
      </Col>
      <DangerousActionModal
        transparent
        hideIcon
        actionHoverColor="primary"
        onAccept={() => changeEnabled()}
        closeModal={() => {
          setIsModalOpen(false);
          setModalItem(null);
        }}
        isOpen={isModalOpen}
        actionText="DEACTIVATE"
        body={
          <div className="d-flex flex-column align-items-center justify-content-center fw-300">
            <SvgRender src={switchIcon} style={{ width: 76, marginBottom: 55 }} />
            <span className="fs-28 fw-400 mb-2">Deactivate</span>
            Are you sure you want to deactivate <br />
            <div>
              <span className="fw-400">{modalItem && modalItem.name}</span> company?
            </div>
          </div>
        }
      />
    </Row>
  );
};

export default Companies;
